export const CHART_LIST = [
                  { 
                    "id": 1, 
                    "value": "Bar", 
                    "label": "Bar Chart", 
                    "maxFieldCount": 2 
                  },
                  { 
                    "id": 2, 
                    "value": "Pie", 
                    "label": "Pie Chart", 
                    "maxFieldCount": 2 
                  }, 
                  { 
                    "id": 3, 
                    "value": "Line", 
                    "label": "Line Chart", 
                    "maxFieldCount": 3 
                  }
                ]


export const COLOR_PALATTE = [

'#f9aeb0',
'#e5c5b6',
'#00457c',
'#11859f',
'#aac8cc',

'#062814',
'#155667',
'#d66f79',
'#d4b564',
'#dfdf96',

'#6f1e2a',
'#9a2f2c',
'#d25335',
'#ff8d47',
'#ffd950',

'#42313a',
'#5a3f46',
'#795b5f',
'#aa7f7b',
'#e3aea4',

'#3f5484',
'#8b6595',
'#ca9fbf',
'#e7d4de',
'#efeddd',

'#4a3845',
'#654b59',
'#926b78',
'#ce9ba2',
'#eacfcd',

'#7c8a80',
'#9c9c9d',
'#4a3e5e',
'#8e818c',
'#c4cfcb',

'#b678ae',
'#df85a2',
'#f7aeac',
'#f8d5bc',
'#f8ecc9',

'#e7d2dd',
'#d8cdc1',
'#213b5a',
'#3f657f',
'#559a9e',

'#8cbda4',
'#c9c9a3',
'#5d284e',
'#a27274',
'#b0a58a',

'#559e9f',
'#aed4bc',
'#8c3f51',
'#8f6e46',
'#9b9a75',
]